export const getStatusColor = (status) => {
  const statusColors = {
    new: 'blue',
    mapped: 'cyan',
    sending: 'orange',
    sent: 'green',
    send_error: 'red',
    integrated: 'green',
    integration_error: 'red',
  };
  return statusColors[status] || 'default';
};

export const getStatusLabel = (status) => {
  const statusLabels = {
    new: 'Nouveau',
    mapped: 'Mappé',
    sending: 'Envoi en cours',
    sent: 'Envoyé',
    send_error: "Erreur d'envoi",
    integrated: 'Intégré',
    integration_error: "Erreur d'intégration",
  };
  return statusLabels[status] || status || 'N/A';
};
